<div class="app-modal-spinner">
  <header class="edit-header"><h1>編集</h1></header>
  <div class="container">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <app-schedule-field
        [staffList]="scheduleService.setDefaultStaff(schedule, staffList)"
        [schedule]="schedule"
        [form]="form"
        [disabled]="disabled"
        [duplicate]="duplicate"
      ></app-schedule-field>
      <app-edit-footer
        excuteText="保存"
        [navigationExtra]="{ queryParamsHandling: 'preserve', replaceUrl: true }"
        [disabled]="form.invalid || disabled"
      ></app-edit-footer>
    </form>
  </div>
</div>
